    document.addEventListener("DOMContentLoaded", function() {
     document.querySelectorAll('.collection-product-atc').forEach(function(button) {
        button.addEventListener('click', function() {
        const btn = this;  
        btn.classList.add('loading'); // --- Show loader ---

        const container = btn.closest('.subscription-container');
        const variantId = btn.dataset.variantId;

        if (!variantId) {
            console.error("No variant ID found on button.");
            btn.classList.remove('loading');
            return;
        }

        // Determine if subscription is selected
        const productId = container.dataset.productId;
        const selectedOption = container.querySelector(`input[name="purchase-option-${productId}"]:checked`)?.value;
        const sellingPlanSelect = container.querySelector('.selling-plan-select');
        const sellingPlanId = (selectedOption === 'subscription' && sellingPlanSelect) ? sellingPlanSelect.value : null;

        // Pre-order products (custom.preorder_enabled) carry the ship date as a visible line
        // property, same as the PDP, so the cart drawer and order show it.
        const preorderMessage = btn.dataset.preorderMessage;

        // Build payload
        const payload = {
            items: [{
            id: variantId,
            quantity: 1,
            ...(sellingPlanId ? { selling_plan: sellingPlanId } : {}),
            ...(preorderMessage ? { properties: { 'Pre-order': preorderMessage } } : {})
            }]
        };

        console.log("Adding to cart:", payload);

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
            },
            body: JSON.stringify(payload)
        })
        .then(response => {
            if (!response.ok) {
            return response.json().then(err => Promise.reject(err));
            }
            return response.json();
        })
        .then(data => {
            console.log("Product added to cart:", data);

            // Open drawer cart if defined
            if (window.openSidecart) window.openSidecart();
            if (window.fetchCart) window.fetchCart();
        })
        .catch(error => {
            console.error(" Error adding to cart:", error);
        })
        .finally(() => {
            btn.classList.remove('loading'); // --- Hide loader ---
        });
        });
    });
});

document.addEventListener("DOMContentLoaded", function() {
  // Loop through all subscription containers on the page
  document.querySelectorAll('.subscription-container').forEach(container => {
    const productId = container.dataset.productId;
    const atcPrice = container.querySelector('.collection-product-atc .coll-atc-price');
    const subRadio = container.querySelector(`#radio-sub-${productId}`);
    const oneTimeRadio = container.querySelector(`#radio-onetime-${productId}`);
    const subPriceEl = container.querySelector('.subscription-discount-price');
    const oneTimePriceEl = container.querySelector('.one-time-discount-price');

    if (!atcPrice || !subRadio || !oneTimeRadio) return;

    // Function to update the Add to Cart button price
    function updatePrice() {
      let newPrice;
      if (subRadio.checked) {
        newPrice = subPriceEl.dataset.discountedPrice || subPriceEl.textContent;
        console.log(`Product ${productId} price updated to SUB: ${newPrice}`);
      } else if (oneTimeRadio.checked) {
        newPrice = oneTimePriceEl.dataset.onetimePrice || oneTimePriceEl.textContent;
        console.log(`Product ${productId} price updated to ONE-TIME: ${newPrice}`);
      }

      if (newPrice) {
        atcPrice.textContent = newPrice.trim();
      }

      // Dryer sheets: strike the regular price on Subscribe, the compare-at price (if any) on One Time
      const comparePrice = container.querySelector('.collection-product-atc .coll-compare-price[data-sub-compare]');
      if (comparePrice) {
        const compare = subRadio.checked ? comparePrice.dataset.subCompare : comparePrice.dataset.otCompare;
        comparePrice.textContent = compare || '';
        comparePrice.style.display = compare ? '' : 'none';
      }
    }

    // Attach 'change' listener to both radios
    [subRadio, oneTimeRadio].forEach(radio => {
      radio.addEventListener('change', updatePrice);
    });

    // Optional: attach click as fallback for some browsers
    [subRadio, oneTimeRadio].forEach(radio => {
      radio.addEventListener('click', updatePrice);
    });

    // Initialize price on page load
    updatePrice();
  });

  console.log(" Subscription listeners applied for all products");
});
  // Collection filter accordion code start here
    document.addEventListener('DOMContentLoaded', function () {
      const accordionQuestions = document.querySelectorAll('.accordion-question');

      accordionQuestions.forEach(question => {
        question.addEventListener('click', () => {
          const answer = question.nextElementSibling;

          // Just toggle this one — no need to close others
          question.classList.toggle('active');
          answer.classList.toggle('active');
        });
      });
    });
  //collection filter accordion code end here  

document.addEventListener('DOMContentLoaded', () => {
  const filterButton = document.querySelector('.filter-heading');
  const filterDrawer = document.querySelector('.coll-filter-inner');
  const body = document.body;
  const closeButton = document.querySelector('.filter-cross'); // close button inside drawer

  // Only run if screen width is mobile
  function isMobile() {
    return window.innerWidth <= 989; // adjust breakpoint if needed
  }

  if (!filterButton || !filterDrawer) return;

  // Overlay for closing
  const overlay = document.createElement('div');
  overlay.className = 'filter-overlay';
  overlay.style.display = 'none';
  document.body.appendChild(overlay);

  // Open drawer
  filterButton.addEventListener('click', () => {
    if (!isMobile()) return; // only mobile
    filterDrawer.classList.add('active');
    body.classList.add('no-scroll');
    overlay.style.display = 'block';
  });

  // Close drawer on overlay click
  overlay.addEventListener('click', () => {
    filterDrawer.classList.remove('active');
    body.classList.remove('no-scroll');
    overlay.style.display = 'none';
  });

  // Close drawer on close button click
  if (closeButton) {
    closeButton.addEventListener('click', () => {
      filterDrawer.classList.remove('active');
      body.classList.remove('no-scroll');
      overlay.style.display = 'none';
    });
  }
});





